import React, { useState, useEffect, useCallback } from 'react'
import './App.css'
import './Home.css'
import axios from 'axios'
import TopBarProgress from 'react-topbar-progress-indicator'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { API_URL } from './config'
import { BiSolidLocationPlus } from 'react-icons/bi'
import { BsArrowUpRight, BsClock } from 'react-icons/bs'

const IndexedEvents = ({ limit = null }) => {
  const [province] = useState('')
  const [currentEvent, setCurrentEvent] = useState([])
  const [userData, setUserData] = useState({
    email: '',
    phone: '',
    customername: '',
  })

  const [loading, setLoading] = useState({
    loadBarProgress: true,
    error: null,
  })

  const customerid = localStorage.getItem('customerid')

  const fetchEvents = useCallback(
    (prov) => {
      const queryProv = prov ? `&province=${prov}` : ''
      const apiUrlCur = `${API_URL}/apps/kscanner/webservices.php?query=INDEXED-EVENTS${queryProv}`

      fetch(apiUrlCur)
        .then((res) => res.json())
        .then((result) => {
          let events = Array.isArray(result) ? result : []

          if (limit) {
            events = events.slice(0, limit)
          }

          setCurrentEvent(events)
          setLoading((prev) => ({
            ...prev,
            loadBarProgress: false,
          }))
        })
        .catch((err) =>
          setLoading((prev) => ({
            ...prev,
            error: err,
            loadBarProgress: false,
          })),
        )
    },
    [limit],
  )

  useEffect(() => {
    if (customerid) {
      axios
        .get(
          `${API_URL}/apps/kscanner/webservices.php?query=CUSTOMERDETAILS&accountid=${customerid}`,
          {
            withCredentials: true,
          },
        )
        .then((response) => {
          setUserData({
            email: response.data.email,
            phone: response.data.phone,
            customername: response.data.customername,
          })
        })
        .catch((err) => console.error('User fetch error:', err))
    }

    fetchEvents(province)
  }, [province, fetchEvents, customerid])

  const date = new Date()

  const fulldate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    '0',
  )}-${String(date.getDate()).padStart(2, '0')}`

  if (loading.error) {
    return (
      <div className="kx-state" role="alert">
        <h3>We couldn't load external events</h3>
        <p>Check your connection and try again.</p>
      </div>
    )
  }

  const visibleEvents = currentEvent.filter(
    (item) => !(item.balance < 3.5 && item.event_day > fulldate),
  )

  return (
    <section className="kx-indexed">
      <div className="kx-head">
        <div>
          <h2 className="kx-head__title">More events from around the web</h2>
          <p className="kx-head__sub">
            Discover events listed on Karamale but ticketed through external platforms.
          </p>
        </div>

        {!loading.loadBarProgress && visibleEvents.length > 0 && (
          <span className="kx-head__count">
            {visibleEvents.length} {visibleEvents.length === 1 ? 'event' : 'events'}
          </span>
        )}
      </div>

      {loading.loadBarProgress && (
        <>
          <TopBarProgress />

          <SkeletonTheme color="#BEC3C9" highlightColor="#e2e2e2">
            <div className="kx-grid">
              {Array.from({ length: 4 }).map((_, i) => (
                <div className="kx-skel" key={i}>
                  <div className="kx-skel__img" />
                  <div className="kx-skel__body">
                    <div className="kx-skel__line" />
                    <div className="kx-skel__line" />
                    <div className="kx-skel__line" />
                  </div>
                </div>
              ))}
            </div>
          </SkeletonTheme>
        </>
      )}

      {!loading.loadBarProgress && visibleEvents.length === 0 && (
        <div className="kx-state">
          <h3>No external events found</h3>
          <p>Check back soon for more events from around the web.</p>
        </div>
      )}

      {!loading.loadBarProgress && visibleEvents.length > 0 && (
        <div className="kx-grid">
          {visibleEvents.map((item, index) => (
            <a
              key={item.eventid || index}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="kx-ticket kx-ticket--external"
              aria-label={`${item.eventname}, external event`}
            >
              <div className="kx-ticket__poster">
                <img
                  src={item.poster}
                  alt=""
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.style.display = 'none'
                  }}
                />

                <span className="kx-ticket__external">External event</span>
              </div>

              <div className="kx-ticket__body">
                <h3 className="kx-ticket__title">{item.eventname}</h3>

                <p className="kx-ticket__place">
                  <BiSolidLocationPlus aria-hidden="true" />
                  <span>{item.location}</span>
                </p>

                <p className="kx-ticket__desc">
                  {item.description
                    ? item.description.replace(/<[^>]*>/g, '').length > 160
                      ? item.description
                          .replace(/<[^>]*>/g, '')
                          .substring(0, 160)
                          .trim() + '…'
                      : item.description.replace(/<[^>]*>/g, '')
                    : ''}
                </p>
              </div>

              <div className="kx-ticket__stub">
                <div className="kx-ticket__when">
                  <strong>{item.sdate}</strong>

                  {item.stime && (
                    <span>
                      <BsClock aria-hidden="true" /> {item.stime}
                    </span>
                  )}
                </div>

                <span className="kx-ticket__cta">
                  View event <BsArrowUpRight aria-hidden="true" />
                </span>
              </div>
            </a>
          ))}
        </div>
      )}
    </section>
  )
}

export default IndexedEvents
